import { Button } from 'components'
import { useRouter } from 'next/router'
import React from 'react'

import { FaqsCategory } from '../data/college.faq'

import FaqComponent from './FaqComponent'

function Faqs() {
  const router = useRouter()
  const isSchoolFaqPage = router.pathname === '/school/faq'
  return (
    <div className="w-full">
      <div className="my-14">
        <h1 className="text-3xl font-medium text-center my-2">
          Frequently Asked Questions
        </h1>
        {/* <p className="text-center">Corem ipsum dolor sit amet</p> */}
      </div>

      <div className="mt-12 lg:mt-0">
        <FaqComponent faqs={FaqsCategory[0].faqs} />
      </div>
      {!isSchoolFaqPage && (
        <div className="flex items-center justify-center my-8">
          <Button
            className="bg-[#3C3C78] hover:bg-[#5A5AB4] text-white"
            onClick={() => router.push('/school/faq')}>
            Explore{' '}
          </Button>
        </div>
      )}
    </div>
  )
}

export default Faqs
